import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import React, {Component} from "react";
import {v4 as uuidv4} from "uuid";
import {withAppContext} from "../util/withAppContext";
import spinner from "../assets/Spinner-1s-200px.svg";
import {prepareBuffer} from "../util/Buffer";
import enterpriseComponentClassFactory from "../eoec/EnterpriseComponentClassFactory";

class PlatformMultiSelect extends Component {

    constructor(props) {
        super(props);
        this.pickValues = props.appContext.sessionContext.getPickValues();
    }

    state = {
        id: uuidv4(),
        fetchBackgroundOperation: false,
        ec: null,
        buffer: [
        ],
    };

    componentDidMount() {
        if (this.props.picklist !== null && this.props.picklist.getStatic() === false) {
            let enterpriseComponentObject = enterpriseComponentClassFactory(this.props.picklist.getEnterpriseComponent());

            let picklistEC = new (enterpriseComponentObject)(this.props.picklist.getEnterpriseComponent());

            this.setState({ec: picklistEC});

            let searchSpecification = this.props.picklist.getSearchSpecification();
            if (searchSpecification !== null) {
                let keys = Object.keys(searchSpecification);
                for (let i = 0; i < keys.length; i++) {
                    let ss = searchSpecification[keys[i]];
                    // eslint-disable-next-line no-template-curly-in-string
                    if (ss.includes("${sessionContext:realm}")) {
                        searchSpecification[keys[i]] = this.props.appContext.sessionContext.getRealm();
                    }
                }
            }

            picklistEC.addLoadStartedListener(this);
            picklistEC.addLoadCompletedListener(this);
            picklistEC.newQuery();
            picklistEC.setSearchSpecification(this.props.picklist.getSearchSpecification());
            picklistEC.executeQuery();
        }
    }

    enterpriseComponentLoadStarted = (ec) => {
        this.setState({fetchBackgroundOperation: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
        let b = prepareBuffer(ec);
        this.setState({buffer: b, fetchBackgroundOperation: false});
    };

    enterpriseComponentLoadCompleted_ = (ec) => {
        let buffer = prepareBuffer(ec);

        if (this.props.defaultOptions !== null && this.props.defaultOptions !== undefined) {
            let entry = {};
            entry[this.props.picklist.getTypeField()] = this.props.defaultOptions.displayValue;
            entry[this.props.picklist.getTypeValue()] = this.props.defaultOptions.value;
            buffer.unshift(entry);
        }

        let copy = [];
        for (let i = 0; i < buffer.length; i++) {
            let found = false;
            for (let j = 0; j < this.props.picklist.getExclusionList().length; j++) {
                if (this.props.picklist.getExclusionList()[j] === buffer[i][this.props.picklist.getTypeValue()]) {
                    found = true;
                }
            }
            if (found === false) {
                copy.push(buffer[i]);
            }
        }
        this.setState({buffer: copy, fetchBackgroundOperation: false});
    };

    getId() {
        if (this.props.id !== undefined && this.props.id !== null && this.props.id !== "") {
            return this.props.id;
        } else {
            return this.state.id;
        }
    }

    render() {
        let renderSpinner = false;

        let content;

        let selectOptions = [];

        if (this.props.picklist.getAllowNoSelection() === true) {
            let option = {
                value: this.props.picklist.getAllowNoSelectionValue(),
                displayValue: this.props.picklist.getAllowNoSelectionDisplayValue(),
            };
            selectOptions.push(option);
        }

        if (this.props.picklist.getStatic() === true) {
            if (this.props.defaultOptions !== undefined) {
                selectOptions.push(this.props.defaultOptions);
            }

            for (let i = 0; i < this.pickValues.length; i++) {
                let pickInstance = this.pickValues[i];

                let pickTypeField = this.props.picklist.getTypeField();
                if (pickInstance[pickTypeField] !== this.props.picklist.getTypeValue()) continue;

                let option = {
                    value: pickInstance["Value"],
                    displayValue: pickInstance["Name"],
                };
                selectOptions.push(option);
            }
        } else if (this.props.picklist.getStatic() === false && this.state.fetchBackgroundOperation === true) {
            renderSpinner = true;
        } else if (this.props.picklist.getStatic() === false && this.state.fetchBackgroundOperation === false) {
            for (let i = 0; i < this.state.buffer.length; i++) {
                let pickTypeField = this.props.picklist.getTypeField();
                let pickValueField = this.props.picklist.getTypeValue();

                let option = {
                    value: this.state.buffer[i].get(pickValueField),
                    displayValue: this.state.buffer[i].get(pickTypeField),
                };
                selectOptions.push(option);
            }
        }

        if (renderSpinner === true) {
            content = (
                <div>
                    <img width="35" height="35" src={spinner} alt="spinner" />
                </div>
            );
        } else {
            const {appContext, defaultOptions, id, label, ...rest} = this.props;

            content = (
                <FormControl fullWidth size="small">
                    <InputLabel id={id + "_label"}>{label}</InputLabel>
                    <Select
                        labelId={id + "_label"}
                        multiple
                        {...rest}
                    >
                        {selectOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.displayValue}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            );
        }

        return (
            <React.Fragment>
                {content}
            </React.Fragment>
        );
    }
}

export default withAppContext(PlatformMultiSelect);
